import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { cloneElement } from 'react';

import type { DatePickerProps } from '@mui/x-date-pickers/DatePicker';
import type { FC } from 'react';
import type { ControllerProps } from 'react-hook-form';

dayjs.extend( utc );
interface MuiTimePickerAdapterProps
  extends Partial<Omit<Parameters<ControllerProps['render']>[0], 'children'>>
{
  children: React.ReactElement<DatePickerProps<string>>;
  isExposingTextField?: boolean;
}

console.log( dayjs.utc( '2023-08-31T12:13:00+02:00' ).toISOString() );

export const MuiTimePickerAdapter: FC<MuiTimePickerAdapterProps> = ({
  children,
  field,
  fieldState,
  formState,
  isExposingTextField = true,
  ...props
}) => (
  <>
    {cloneElement( children, {
      // @ts-expect-error
      value: fieldState?.invalid
        // empty string will trigger DatePicker to display the error state
        ? ''
        : field?.value
        // if field value exists, it will be a iso date string. Parse string back to dayjs object
        ? dayjs( field.value )
        : null,
      onChange: (data: dayjs.Dayjs) => {
        // parse dayjs object to iso date string, so zod can validate it.
        field?.onChange( dayjs( data ).format() );
      },
      slotProps: {
        textField: {
          // display zod validation error message
          // if no error message, display whitespace to force the rendering of the paragraph. Preventive action to preventing content shifting
          helperText: fieldState?.error?.message ?? ' ',
        },
      },
      ...props,
    } )}
  </>
);
